import { react2panel } from 'common/util/react2panel';
import { InsightsLineChartReact } from './index';
export const InsightsLineChartEl = react2panel("mp-insights-line-chart", InsightsLineChartReact, {
  contexts: ["segmentFilterController"]
});